var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.absolute && !_vm.$vuetify.breakpoint.mobile ? 'logout': 'mx-auto py-3']},[_c('v-btn',{staticClass:"secondary j-btn white--text cursor-pointer",on:{"click":_vm.logout}},[_vm._v("Déconnexion")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }